import React, { useEffect, useState } from "react";

import { AnimatePresence, motion } from "framer-motion";

interface AnimationContainerProps {
  contentKey: string | number | null | undefined;
  children: React.ReactNode;
  variants?: Record<string, any>;
  onExitComplete?: () => void;
  exitBeforeEnter?: boolean;
  height?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

const defaultVariants = {
  initial: { opacity: 0, x: "-20px" },
  animate: {
    opacity: 1,
    x: "0px",
    transition: { duration: 0.4, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    x: "20px",
    transition: { duration: 0.4, ease: "easeIn" },
  },
};

const AnimationContainer: React.FC<AnimationContainerProps> = ({
  contentKey,
  children,
  variants = defaultVariants,
  onExitComplete,
  exitBeforeEnter = true,
  style,
  className,
}) => {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);

    return () => {
      setHasMounted(false);
    };
  }, []);

  const shouldAnimate = contentKey !== null && contentKey !== undefined;

  if (!shouldAnimate) {
    // Render without animation
    return (
      <div style={style} className={className}>
        {children}
      </div>
    );
  }

  return (
    <AnimatePresence
      onExitComplete={onExitComplete}
      exitBeforeEnter={hasMounted && exitBeforeEnter}
    >
      <motion.div
        key={contentKey}
        variants={variants}
        initial="initial"
        animate="animate"
        exit={hasMounted ? "exit" : {}}
        style={style}
        className={className}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default AnimationContainer;
